module.exports = __webpack_public_path__ + "static/media/woo16.f96c5319.png";